import { AlertTriangle, ArchiveX, Boxes, ClipboardList, Truck } from "lucide-react";

export const PAGE_SIZE = 10;
export const BORDER = "#f2c6cc";

export const ALL_TABS = [
  { key: "stock", label: "Stock", icon: Boxes },
  { key: "alerts", label: "Stock Alerts", icon: AlertTriangle },
  { key: "expired", label: "Expired Stock", icon: ArchiveX },
  { key: "orders", label: "Order Requests", icon: ClipboardList },
  { key: "inbound", label: "Inbound Receipts", icon: Truck },
];

export const INVENTORY_TABS = ALL_TABS.filter(
  (item) => item.key !== "stock" && item.key !== "inbound"
);